import React from 'react';
import moment from "moment";
import _ from 'lodash'
import numberFormat from "../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute} from "../../routesConstants";

const RateHawkDay = ({info,label, full}) => {
  console.log(info)
  const total = _.sumBy(info, 'toPay')
  if(full){
    return (
      <div>
        <div style={{padding:'1rem 25px',
          backgroundColor:label?.color || 'rgba(253,57,122,0.13 )'}} className={'d-flex justify-content-between align-items-center'}>
          <b>{label?.name}</b>
          <div>
            Отелей: {info.length}, Сумма: {numberFormat(total)} KZT
          </div>
        </div>
        {info.map((item,index)=>{
          const margin = index===0 ? '1rem 0 1rem 0' : index === info.length-1 ? '0 0 1rem 0' : '0'
          return <div key={index} style={{padding: '0 25px', margin}}>
            <div className={'d-flex'}>
              {item.hotel}
              {item.forVisa && <div className={'text-danger ml-2 d-flex align-items-center gap-2'}>
                <i className="fa fa-exclamation-triangle"/>
                ДЛЯ ВИЗЫ
                <i className="fa fa-exclamation-triangle"/>

              </div>}

            </div>
            {item.rooms.join(";")}
            <br/>
            <br/>
            <div style={{opacity: 0.8}}>
              {!!item.orderId ?
                <Link className={'text-decoration-underline'} to={TouristServicesEditRoute + item.orderId}
                      target={'_blank'}><b>{item.invoice}</b></Link>
                : item.invoice} от {item.issueDate} {item.issuedBy}<br/>

            </div>
            {item.startDate.slice(0, 5)}-{item.endDate.slice(0, 5)} {item.pax}<br/>
            <div className={'d-flex justify-content-between align-items-center'}>
              <div>{numberFormat(item.toPay)} KZT ({moment().locale("ru").to(moment(item.paymentDue))})</div>
              <div>
                <div className={'text-end'}>{item.freeCancellation ?
                  <div>Отмена до
                    :{moment(item.freeCancellation).format('DD.MM.YYYY HH:mm')} {moment(item.freeCancellation).diff(moment(), 'hours') < 24 ?
                      <i className="fa fa-exclamation-triangle text-danger"/> : ''}</div>
                  : 'Нет бесплатной отмены'}</div>
                <div>Оплатить до: {moment(item.paymentDue).format('DD.MM.YYYY HH:mm')}</div>
              </div>
            </div>
            {index !== info.length - 1 && <hr/>}
          </div>
        })}
      </div>
    );
  } else {
    return <>
      {info.map((item, index) => {
        return <div key={index} style={{padding: '0 25px'}}>
          <div className={'d-flex'}>
            {item.hotel}
            {item.forVisa && <div className={'text-danger ml-2 d-flex align-items-center gap-2'}>
              <i className="fa fa-exclamation-triangle"/>
              ДЛЯ ВИЗЫ
              <i className="fa fa-exclamation-triangle"/>
            </div>}

          </div>
          {item.startDate.slice(0, 5)}-{item.endDate.slice(0, 5)} {item.pax} {numberFormat(item.toPay)} KZT<br/>
          <br/>
        </div>
      })}
    </>
  }

};

export default RateHawkDay;
